import { render, staticRenderFns } from "./room.vue?vue&type=template&id=44cb01d9&"
import script from "./room.vue?vue&type=script&lang=js&"
export * from "./room.vue?vue&type=script&lang=js&"
import style0 from "./room.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports